module.exports = __webpack_public_path__ + "static/media/404truck.0d2308ad.svg";